export enum PublicEventNames {
  TOKEN_EXPIRED = "token_expired",
}
